import { Grid } from "@mui/material";
import { useEffect } from "react";
import MensajeApoderadoCardImg from "../../components/UmmIApps/Cards/MensajeApoderadoCardImg.png";
import { useTranslation } from "react-i18next";
import { UseSetLenguajePorPais } from "../../hooks/UseSetLenguajePorPais";
import AccionRequerida from "../../components/Form/Fields/AccionRequerida";
import Asunto from "../../components/Form/Fields/Asunto";
import Destinatario from "../../components/Form/Fields/Destinatario";
import FechaHora from "../../components/Form/Fields/FechaHora";
import LongitudResponderCorreo from "../../components/Form/Fields/LongitudResponderCorreo";
import Objetivo from "../../components/Form/Fields/Objetivo";
import TonoMensajeApoderado from "../../components/Form/Fields/TonoMensajeApoderado";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

const MensajeApoderadoPage = () => {
  const { handleBack, setTextoInicial, handleInitialPromptData, promptData } =
    useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  // const isButtonDisabled = !(gradoId && materiaId && promptData.tema && isOAAdded);

  useEffect(() => {
    const init = {
      tono_mensaje: "",
      destinatario: "",
      asunto: "",                           
      objetivo: "",
      accion_requerida: "",
      fecha_hora: "",
      longitud: 120,
    };
    handleInitialPromptData(init, "comunicacion");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti. Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);      
  
  const isButtonDisabled =  isSendButtonDisabled("mensaje_apoderado", { promptData });

  const colorIconBack = "#6A93A8";

  const { t } = useTranslation(); // Hook de traducción

  //Hook para lenguaje según país
  UseSetLenguajePorPais();

  console.log(promptData);
  

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={MensajeApoderadoCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #C3D4DC 100%, #88A9B9 100%)"
        }
        title={t("mensajeApoderadoTitle")}
        description={`Optimiza la comunicación con los ${t(
          "apoderados"
        )} mediante nuestra herramienta de generación de cartas. En cuestión de minutos, podrás redactar comunicados profesionales y personalizados para cualquier ocasión.`}
        titleColor="#88A9B9"
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Destinatario />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Objetivo />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Asunto />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <AccionRequerida />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <FechaHora />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <TonoMensajeApoderado />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <LongitudResponderCorreo />
        </Grid>
      </UmmiaAppsLayout>
    </>
  );
};

export default MensajeApoderadoPage;
